import { useState } from "react";

/**
 *
 * @param {起源値} initialValue
 * @param {キーまたはIDプロパーティ名} keyName
 * @returns
 */
const useArrayObject = (initialValue) => {
  const [value, setValue] = useState(initialValue || []);

  /**
   * 配列のIndexにある対象を編集する
   * @param {配列のIndex} key
   * @param {新しい値} newValue
   */
  const updateIndex = (index, newValue) => {
    setValue((prevValue) => {
      if (index >= 0 && index < prevValue.length) {
        const newArr = [
          ...prevValue.slice(0, index),
          newValue, // Assuming newValue is a complete new object
          ...prevValue.slice(index + 1),
        ];
        return newArr;
      }
      return prevValue;
    });
  };

  /**
   *　Objectをキーで編集する
   * @param {Objectのキー} keyName
   * @param {Objectの新たなデータ（キーを含む）} newValue
   */
  const updateByKey = (keyName, newValue) => {
    setValue((prevValue) => {
      const index = prevValue.findIndex(
        (x) => x[keyName] === newValue[keyName]
      );
      if (index !== -1) {
        const newArr = [
          ...prevValue.slice(0, index),
          newValue, // Assuming newValue is a complete new object with the same key
          ...prevValue.slice(index + 1),
        ];
        return newArr;
      }
      return prevValue;
    });
  };

  /**
   * 配列のIndexにある対象のプロパーティを編集する
   * @param {配列のIndex} key
   * @param {Objectのプロパーティ名} property
   * @param {新しい値} newValue
   */
  const updateIndexProp = (index, property, newValue) => {
    setValue((prevValue) => {
      if (index >= 0 && index < prevValue.length) {
        // Create a new object with the updated property value
        const updatedItem = { ...prevValue[index], [property]: newValue };
        // Create a new array with the updated object
        const newArr = [
          ...prevValue.slice(0, index),
          updatedItem,
          ...prevValue.slice(index + 1),
        ];
        return newArr;
      }
      return prevValue;
    });
  };

  /**
   * 配列に対象を追加する
   * @param {新しい対象} newElement
   */
  const push = (newElement) => {
    setValue((prevValue) => [...prevValue, newElement]);
  };

  /**
   * 配列に対象をスタートに追加する
   * @param {新しい対象} newElement
   */
  const unshift = (newElement) => {
    setValue((prevValue) => [newElement, ...prevValue]);
  };

  /**
   * 配列に対象配列を追加する
   * @param {新しい対象配列} newElementArray
   */
  const concat = (newElementArray) => {
    setValue((prevValue) => [...prevValue, ...newElementArray]);
  };

  return {
    Value: value,
    setValue,
    updateIndex,
    updateIndexProp,
    push,
    unshift,
    updateByKey,
    concat,
  };
};

export default useArrayObject;
